import { create } from 'zustand';

export interface UseOverlapWindowInterface {
  active: boolean;
  setActive: (val: boolean) => void;
}

export const useOverlapWindow = create<UseOverlapWindowInterface>((set) => ({
  active: false,
  setActive: (val) =>
    set(() => ({
      active: val,
    })),
}));
